import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Bill, BillingInfo, BillStatus } from "src/app/shared/types/contract-types";
import { EInvoiceResponse } from "../types/e-invoice";

@Injectable({
  providedIn: "root",
})
export class BillService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/bill/${endpoint}`;
  }

  // bill

  addBill(contracId: number, body: any): Observable<Bill> {
    return this.http.post<Bill>(
      this.apiUrlWithEndpoint(`contract/${contracId}`),
      body,
    );
  }

  getBill(id: number): Observable<Bill> {
    return this.http.get<Bill>(this.apiUrlWithEndpoint(`${id}`));
  }

  getBillingInformation(): Observable<BillingInfo> {
    return this.http.get<BillingInfo>(this.apiUrlWithEndpoint(`information`));
  }

  getBills(contracId: number): Observable<Bill[]> {
    return this.http.get<Bill[]>(
      this.apiUrlWithEndpoint(`contract/${contracId}`),
    );
  }

  getAllBills() {
    return this.http.get<Bill[]>(this.apiUrlWithEndpoint(""));
  }

  updateBillStatus(id: number, billStatus: BillStatus): Observable<Bill> {
    return this.http.put<Bill>(
      this.apiUrlWithEndpoint(`${id}`),
      billStatus,
    );
  }

  downloadBill(contractId: number, billId: number): Observable<Blob> {
    const url = this.apiUrlWithEndpoint("download");
    const body = { contractId, billId, emails: [] };
    return this.http.post(url, body, { responseType: "blob" });
  }

  sendMailToCustomer(contractId: number, billId: number, emails: string[]): Observable<string> {
    return this.http.post(
      this.apiUrlWithEndpoint("customer/send"),
      {
        contractId,
        billId,
        emails,
      },
      { responseType: "text" },
    );
  }

  generateBillHtml(id: number): Observable<string> {
    return this.http.get(`${this.apiUrl}/api/Bill/${id}/generate`, { responseType: "text" });
  }

  getNumberOfPlanToPay(billId: number): Observable<number> {
    return this.http.get<number>(this.apiUrlWithEndpoint(`${billId}/plans-to-pay`));
  }

  deleteBillById(billId: number) {
    return this.http.delete(this.apiUrlWithEndpoint(`${billId}`));
  }

  getEInvoiceByBillId(id: number): Observable<EInvoiceResponse> {
    return this.http.get<EInvoiceResponse>(`${this.apiUrl}/api/Bill/e-invoice/${id}`);
  }
}
